import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../utils/AppConstants';
import { AppEnums } from '../../../models/AppEnums';
import { Camera, CameraConfigurationDetail, CameraManageConfigHikVision, CameraManageConfigVigilate } from '../../../models/Camera';
import { CameraService } from '../../../services/camera.service';
import { AlertService } from '../../shared/alert/alert.service';
import { HikVisionConfigsComponent } from '../hikvision-configs/hikvision-configs.component';
import { VigilareConfigsComponent } from '../vigilate-configs/vigilate-configs.component';

@Component({
  selector: 'app-camera-detail',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    ConfirmAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    HikVisionConfigsComponent,
    VigilareConfigsComponent],
  templateUrl: './camera-detail.component.html',
  styleUrl: './camera-detail.component.scss',
})
export class CameraDetailComponent implements OnInit, OnDestroy {
  paramSubscription!: Subscription;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  manageConfiguration: CameraConfigurationDetail = { auth: {} };
  id?: number;
  camera: Camera = {};
  detail_title: string = 'Nuova camera';

  cameraTypes = AppEnums.cameraTypes
  cameraDetectionModes = AppEnums.cameraDetectionModes
  constructor(
    private cameraService: CameraService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    fullSpinnerService.spinner(undefined);
  }
  ngOnInit(): void {

    this.paramSubscription = this.activatedRoute.params.subscribe(parameter => {
      this.id = parameter['id'];
      if (this.id! > 0) {
        this.fullSpinnerService.spinner('');
        this.cameraService.get(this.id!).subscribe({
          next: (res) => {

            this.camera = res;
            if (res.manageConfigs) {
              this.manageConfiguration.auth = JSON.parse(res.manageConfigs!);
              if (this.camera.manageConfigsType == "HIKVISION") {
                this.manageConfiguration = this.manageConfiguration as CameraConfigurationDetail<CameraManageConfigHikVision>;
              } else if (this.camera.manageConfigsType == "VIGILATE") {
                this.manageConfiguration = this.manageConfiguration as CameraConfigurationDetail<CameraManageConfigVigilate>;
              }
            }
            this.detail_title = res.name!;
          }, complete: () => {
            this.fullSpinnerService.spinner(undefined);
          }
          , error: () => {
            this.fullSpinnerService.spinner(undefined);
          }
        });
      }
    });
  }
  onSubmit(loginForm: NgForm): void {
    if (loginForm.valid) {
      this.fullSpinnerService.spinner('');
      this.camera.manageConfigs = JSON.stringify(this.manageConfiguration.auth);
      if (!this.camera.manageConfigsType || this.camera.manageConfigsType == 'NONE')
        this.camera.manageConfigs = undefined;
      this.cameraService.save(this.camera).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.router.navigate(['cameras']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

  back() {
    this.router.navigate(['cameras']);
  }

  confirmDelete() {
    this.showConfirmationModal = true;
    this.confirmationMessage = "Sicuro di voler eliminare la camera " + this.camera.name + ' ?';
  }

  cancelDelete() {
    this.showConfirmationModal = false;
  }

  delete() {
    this.fullSpinnerService.spinner('');
    this.cameraService.delete(this.camera.id!).subscribe({
      next: (res) => {
        this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
        this.router.navigate(['cameras']);
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}



